import { render, staticRenderFns } from "./CampaignBuilder.vue?vue&type=template&id=2a865b5d&scoped=true"
import script from "./CampaignBuilder.vue?vue&type=script&lang=js"
export * from "./CampaignBuilder.vue?vue&type=script&lang=js"
import style0 from "./CampaignBuilder.vue?vue&type=style&index=0&id=2a865b5d&prod&scoped=true&lang=css"
import style1 from "./CampaignBuilder.vue?vue&type=style&index=1&id=2a865b5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a865b5d",
  null
  
)

export default component.exports